import { render, staticRenderFns } from "./comp_AboutWhisky-D-Blog.vue?vue&type=template&id=2c38d796&"
import script from "./comp_AboutWhisky-D-Blog.vue?vue&type=script&lang=js&"
export * from "./comp_AboutWhisky-D-Blog.vue?vue&type=script&lang=js&"
import style0 from "./comp_AboutWhisky-D-Blog.vue?vue&type=style&index=0&id=2c38d796&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
